var $ = jQuery.noConflict();

$(window).on('load', function () {
    let method = 'front';
    if ($('body').hasClass('wp-admin'))
        method = 'wp-admin';

    var initializeBlock = function ($block) {

        $('#select-sortby').on('change', function () {
            let val = $(this).val();
            let parent_form = $(this).closest('.block-news-listing').find('.block-news-listing__filters');
            parent_form.find('input[name=sort]').val(val);
            parent_form.submit();
        });
        if (!$('.block-news-listing__filters select.filter-subcategory').hasClass('init')) {
            $('.block-news-listing__filters .subcat-input').hide(0);
            if ($('.block-news-listing__filters select.filter-category').val() != '') {
                getSubcategoryOptions($('.block-news-listing__filters select.filter-category').val());
            }
        }

        $('.block-news-listing__filters select.filter-category').on('change', function () {
            getSubcategoryOptions($(this).val());
        });

        function getSubcategoryOptions(catSlug) {
            let targetInputWrapper = $('.block-news-listing__filters .subcat-input');
            if (catSlug == '') {
                targetInputWrapper.find('select.filter-subcategory').val('').change();
                targetInputWrapper.hide(0);
                return false;
            }

            jQuery.ajax({
                type: "GET",
                url: phpvars.ajax_url,
                data: 'action=blog_subcategory&subcatSlug=' + catSlug,
                success: function (data) {
                    var response = JSON.parse(data);
                    if (response.subCatStatus == 'empty') {
                        targetInputWrapper.hide(0);
                        targetInputWrapper.find('select.filter-subcategory').val('').change();
                    } else {
                        targetInputWrapper.find('select.filter-subcategory').html(response.html);
                        targetInputWrapper.show(0);
                    }
                },
                error: function (errorThrown) {
                }
            });
        }
    };

    window.onload = function () {
        initializeBlock($(this));
    }();

    if (window.acf) {
        window.acf.addAction('render_block_preview/type=news-listing', initializeBlock);
    }

    $('.block-news-listing__filters .search-submit').click(function(e){
        if($(this).parents('.input-wrapper').find('input').val().length < 1){
            e.preventDefault();
        }
    });
});
